import React from "react";
import banner3 from "../assets/banner3.jpg"; // replace with actual image path

export default function FeasibilityEvaluations() {
  return (
    <section className="py-5">

      {/* Heading */}
      <div className="text-center mb-3">
        <h2 className="main-section-title fw-bold">Feasibility Studies & Evaluations</h2>
        <p className="text-muted small">
          Assessing project viability and measuring impact for informed decisions.
        </p>
      </div>

      {/* Image */}
      <div className="mb-4">
        <img 
          src={banner3} 
          alt="Feasibility Studies & Evaluations" 
          className="img-fluid rounded w-100"
        />
      </div>

      {/* Elaborative Text */}
      <div className="container">
        <p className="text-muted fs-6">
          Zamani Sabios Group conducts comprehensive feasibility studies and evaluations 
          to help organisations make informed decisions. Our services include baseline 
          studies, mid-term reviews, end-line evaluations, and performance assessments 
          for programmes and projects. We combine qualitative and quantitative methods, 
          stakeholder consultations, and evidence-based analysis to ensure that projects 
          are viable, impactful, and aligned with organisational objectives.
        </p>
      </div>

    </section>
  );
}
